import { useMemo } from 'react';
import Box from '@mui/material/Box';
import ReactCountryFlag from 'react-country-flag';
import { countries } from '../../../static-data/countries';
import AutocompleteField from '../../../ui/primitives/AutocompleteField ';

const COUNTRY_OPTIONS = countries;

const renderCountryContent = (country, flagSize) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <ReactCountryFlag
      countryCode={country.code}
      svg
      style={{ fontSize: flagSize }}
    />
    {country.label}
  </Box>
);

const CountrySelect = ({ selectedValues = [], setSelectedValues }) => {
  const normalizedValues = useMemo(
    () =>
      selectedValues.map((v) =>
        typeof v === 'string'
          ? (COUNTRY_OPTIONS.find((c) => c.label === v) ?? { label: v, code: '' })
          : v,
      ),
    [selectedValues],
  );

  const handleChange = (newValues) => {
    setSelectedValues(newValues.map((v) => v.label));
  };

  return (
    <AutocompleteField
      id="country-select"
      label="Select Countries"
      multiple
      value={normalizedValues}
      onChange={handleChange}
      options={COUNTRY_OPTIONS}
      placeholder="Countries"
      filterSelectedOptions
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.code === value.code}
      limitTags={7}
      renderOption={(option) => renderCountryContent(option, '1.4rem')}
      renderTag={(option) => renderCountryContent(option, '1rem')}
    />
  );
};

export default CountrySelect;